import { cn } from "@/lib/utils";

export const SectionHeading = ({
    eyebrow,
    title,
    description,
    alignment = "left",
    className = "",
}) => {
    const alignmentClasses = {
        left: "text-left",
        center: "text-center mx-auto",
        right: "text-right ml-auto",
    };

    return (
        <div className={cn("max-w-2xl", alignmentClasses[alignment], className)}>
            {eyebrow && (
                <span className="font-sans text-xs tracking-wide-premium uppercase text-gold mb-4 block">
                    {eyebrow}
                </span>
            )}
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-6 leading-tight">
                {title}
            </h2>
            {description && (
                <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed">
                    {description}
                </p>
            )}
        </div>
    );
};

export const GoldDivider = ({ className = "" }) => {
    return (
        <div className={cn("flex items-center justify-center", className)}>
            <div className="gold-line w-16" />
        </div>
    );
};

export const GoldDividerLeft = ({ className = "" }) => {
    return (
        <div className={cn("flex items-center", className)}>
            <div className="gold-line w-12" />
        </div>
    );
};

export default SectionHeading;
